import { Link } from '@tanstack/react-router'
import { Hanko } from './Hanko'
import { LocaleSwitch } from './LocaleSwitch'
import { useLocale } from './use-locale'

export function SiteFooter() {
  const { t, path } = useLocale()
  return (
    <footer className="site-footer">
      <div className="site-footer__brand">
        <Hanko size={30} className="brand__seal" />
        <span className="site-footer__name">Focus Cafe</span>
        <span className="site-footer__tag">{t.receipt.tagline}</span>
      </div>
      <nav className="site-footer__nav" aria-label={t.nav.home}>
        <Link to={path('/ranking')}>{t.nav.ranking}</Link>
        <Link to={path('/pomodoro')}>{t.nav.pomodoro}</Link>
        <Link to={path('/terms')}>{t.nav.terms}</Link>
        <Link to={path('/privacy')}>{t.nav.privacy}</Link>
        <LocaleSwitch />
      </nav>
      <p className="site-footer__copy">© {new Date().getFullYear()} Focus Cafe</p>
    </footer>
  )
}
